<template>
  <router-view />
</template>

<style lang="scss">
body {
  font-family: "Inter", sans-serif;
}
</style>
